import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['banner']

  connect() {
    // The preview banner is redundant when the page is embedded in the CMS
    // preview iframe, so drop it when we're not the top-level window.
    if (this.hasBannerTarget && window.self !== window.top) {
      this.bannerTarget.remove()
    }

    this.boundNeutralizeLink = this.#neutralizeLink.bind(this)
    document.addEventListener('click', this.boundNeutralizeLink, true)
  }

  disconnect() {
    document.removeEventListener('click', this.boundNeutralizeLink, true)
  }

  // Keep previews self-contained by blocking navigation away from the page,
  // while still allowing in-page anchor links to jump within it.
  #neutralizeLink(event) {
    const link = event.target.closest('a[href]')
    if (!link || link.getAttribute('href').startsWith('#')) return

    event.preventDefault()
    event.stopPropagation()
  }
}
